/**
 * Extract a user-friendly error message from an HTTP error response.
 * Walks the common API error structures in priority order.
 */
export function extractErrorMessage(error: any): string {
	if (error?.error?.error?.details?.description) {
		return error.error.error.details.description;
	}
	if (error?.error?.message) {
		return error.error.message;
	}
	if (error?.message) {
		return error.message;
	}
	return 'An error occurred. Please try again.';
}
